import { useState } from 'react'
import { useGraphQLErrorSubscribe } from './useGraphQLPubsubError'
import { type DocumentNode, type OperationTypeNode, OperationDefinitionNode } from 'graphql'

export enum MODAL_TYPE {
  API_RATE_LIMIT = 'API_RATE_LIMIT',
  SESSION_EXPIRED = 'SESSION_EXPIRED',
  SYSTEM_PROCESSING = 'SYSTEM_PROCESSING',
  HATO_HEART_SYSTEM_ERROR = 'HATO_HEART_SYSTEM_ERROR',
  FOOD_PASSION_SYSTEM_ERROR = 'FOOD_PASSION_SYSTEM_ERROR',
  GENERIC_SYSTEM_ERROR = 'GENERIC_SYSTEM_ERROR',
}

interface useModalServiceErrorProps {
  isHatoHeart: boolean
  isFoodPassion: boolean
}

const useModalServiceError = ({ isHatoHeart = false, isFoodPassion = false }: useModalServiceErrorProps) => {
  const [modalType, setModalType] = useState<MODAL_TYPE>()
  const [errorOperationType, setErrorOperationType] = useState<OperationTypeNode>()

  useGraphQLErrorSubscribe(({ extensions, query }) => {
    const { status, errorCode, statusText } = extensions

    if (status === 429) {
      setModalType(MODAL_TYPE.API_RATE_LIMIT)
      return
    }

    if (status === 401) {
      setModalType(MODAL_TYPE.SESSION_EXPIRED)
      return
    }

    if (status === 409 && errorCode === 'UNDER_PROCESSING' && statusText === 'Conflict') {
      setModalType(MODAL_TYPE.SYSTEM_PROCESSING)
      return
    }

    if (isHatoHeart) {
      setModalType(MODAL_TYPE.HATO_HEART_SYSTEM_ERROR)
    } else if (isFoodPassion) {
      setModalType(MODAL_TYPE.FOOD_PASSION_SYSTEM_ERROR)
    } else {
      setModalType(MODAL_TYPE.GENERIC_SYSTEM_ERROR)
    }

    const operationType = getOperationType(query)
    setErrorOperationType(operationType)
  })

  const resetModal = () => {
    setModalType(undefined)
    setErrorOperationType(undefined)
  }

  return { modalType, errorOperationType, resetModal }
}

export default useModalServiceError

const getOperationType = (query: DocumentNode | null) => {
  const result = query?.definitions.find((def) => def.kind === 'OperationDefinition') as
    | OperationDefinitionNode
    | undefined
  return result?.operation
}
